import { render, staticRenderFns } from "./stay-case-query.vue?vue&type=template&id=387a4961"
import script from "./stay-case-query.vue?vue&type=script&lang=ts"
export * from "./stay-case-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports